import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";
import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";

@Component({
	selector: "obg-request-cpf-dialog",
	templateUrl: "./request-cpf-dialog.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class RequestCpfDialogComponent {
	@HostBinding("class.obg-request-cpf-dialog") hostCssClass = true;

	constructor(private dialogRef: MatDialogRef<RequestCpfDialogComponent>) {}

	cpfFormSubmission(cpfEvent: CustomEvent) {
		if (cpfEvent && typeof cpfEvent?.detail === "string") {
			this.dialogRef?.close(cpfEvent.detail);
		}
	}
}
